import Component from '../../js/_Component';

const CNAME = 'c-block-affiliation-form';

export default class BlockAffiliationForm extends Component {

	private form: HTMLFormElement;

	private formLoader: HTMLFormElement;

	private fields: (HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement)[];

	private formHeader: HTMLElement;

	private successMessage: HTMLElement;

	private failureMessage: HTMLElement;

	private outgoingEndpoint: string;

	constructor(element: HTMLElement) {
		super(element);

		const affSelect = this.element.querySelector(`.${CNAME}--affiliation-select select`) as HTMLSelectElement;
		const submitButton = this.element.querySelector(`.${CNAME}--submit button`) as HTMLButtonElement;

		this.formHeader = element.querySelector(`.${CNAME}--header`);
		this.form = element.querySelector(`.${CNAME}--form`);
		this.formLoader = element.querySelector(`.${CNAME} .c-block-loader-form`);
		this.fields = Array.from(element.querySelectorAll('[name]'));
		this.successMessage = element.querySelector(`.${CNAME}--message.m-success`);
		this.failureMessage = element.querySelector(`.${CNAME}--message.m-failure`);

		this.appId = document.querySelector('body').dataset.appid ?? 'dev';

		this.outgoingEndpoint = "/api/email.php";
		// 'test action guarantees that reCaptcha v3 will return score higher than .5
		this.recaptchaAction = document.location.hostname.includes('dev') ? 'test' : `${this.appId}_newsletter`;

		// Submit Function
		this.form.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
		});

		// Watch affiliation select for changes
		if(affSelect){
			affSelect.addEventListener('change', () => this.updateVisibleFields(affSelect.value));
		}
	}

	updateVisibleFields(selectValue: string) {
		// https://gist.github.com/thevangelist/8ff91bac947018c9f3bfaad6487fa149
		const kebabCase = str => str.match(/[A-Z]{2,}(?=[A-Z][a-z0-9]*|\b)|[A-Z]?[a-z0-9]*|[A-Z]|[0-9]+/g)
		.filter(Boolean)
		.map(x => x.toLowerCase())
		.join('-');

		let selectValueCam = kebabCase(selectValue);

		// Hide all answer fields
		this.element.querySelectorAll('[class*="-answer-"]').forEach(function(thisEl: HTMLElement){
			thisEl.classList.add('m-hide');
			thisEl.getElementsByTagName("input")[0].removeAttribute('required');
		});

		// Show applicable fields
		this.element.querySelectorAll( `.${CNAME}--answer-${selectValueCam}`).forEach(function(thisEl: HTMLElement){
			thisEl.classList.remove('m-hide');
			thisEl.getElementsByTagName("input")[0].setAttribute('required','');
		});
	}

	recaptchaCallBack() {
		// Find all inputs
		const data = this.collectData();

		// Check to make sure we didn't get false.
		if(data == false){
			// Data failed
			return;
		}

		const fetchOptions = {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(data),
		};

		this.formLoader.classList.remove('m-hide');
		this.form.classList.add('m-form-hide');

		// If there is no endpoint, stop.
		if(this.outgoingEndpoint.length > 1) {
		fetch(this.outgoingEndpoint, fetchOptions)
			.then((response) => response.json())
			.then((response) => this.onSuccess(response))
			.catch(() => this.onFailure());
		} else {
			console.log("No endpoint");
			console.log(data);
		}
	}

	recaptchaV3(){
		let _self = this;
		let recaptchaSiteEl = document.getElementById("recaptcha-response");
		if(recaptchaSiteEl){
			var recaptchaSiteKey = recaptchaSiteEl.dataset.parameter;
			grecaptcha.ready(function() { // Wait for the recaptcha to be ready
				console.log(_self.recaptchaAction);
				grecaptcha
					.execute(recaptchaSiteKey, {
						action: _self.recaptchaAction
					}) // Execute the recaptcha
					.then(function(token){
						let recaptchaResponse = document.getElementById("recaptcha-response");
						recaptchaResponse.value = token // Set the recaptcha response
					}).then(function(){
							_self.recaptchaCallBack();
					});
			});
		}else{
			_self.recaptchaCallBack();
		}
	}

	submit(){
		// set recaptcha token to submit to backend
		this.recaptchaV3();
	}

	reset(){
		this.form.reset();
		this.form.classList.remove("m-hide");
		const hiddenElements = this.element.querySelectorAll('[data-default="hide"]');
		for (const element of hiddenElements) {
		  element.classList.add("m-hide");
		}
		//this.successMessage.classList.add("m-hide");
	}

	collectData() {
		const data = {};
		let missingData = false;

		let humanName;

		this.fields.forEach((field) => {
			// Get the root of this field
			let componentRoot = field.closest("."+field.classList[0].split("--")[0]);

			// Checkbox handling
			// Basically if a checkbox exists and its filled out, send it.
			// Otherwise just ignore it. Because checkboxes be that way.
			if(field.type == "checkbox") {
				let chechbox = field as HTMLInputElement;
				if (chechbox.checked) {
					humanName = field.name.replace(/-/g," ").replace(/(\b[a-z](?!\s))/g,function(tempStr){
						return tempStr.toUpperCase();
					});
					data[humanName] = field.value;
				} else {
					return;
				}
			}

			// If something got through and was required, but is blank. Stop.
			if (field.hasAttribute("required")){

				// Remove error class if it exists
				componentRoot.classList.remove('invalid');

				// Email handling
				// See https://developer.mozilla.org/en-US/docs/Learn/Forms/Form_validation
				// This is a very simplified version of what it could be
				if (field.type == "email") {
					let emailRegExp = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
					if(!emailRegExp.test(field.value)){
						missingData = true;
						componentRoot.classList.add('invalid');
					} else {
						// Pass
					}
				}

				// Blank field check
				if (field.value == ""){
					missingData = true;
					// Add class to field that there's an error
					componentRoot.classList.add('invalid');
				}
			}

			// No special handling? Have some data.
			humanName = field.name.replace(/-/g," ").replace(/(\b[a-z](?!\s))/g,function(tempStr){
				return tempStr.toUpperCase();
			});
			data[humanName] = field.value;
		});

		// If signup wasn't found, explicitly let's just give it a value.
		data["Sign Up"] = data["Sign Up"] || "Not Checked / No";

		// This is the affiliation form so we'll set the subject
		data["subject"] = "Affiliation";

		if(missingData){
			// Don't send data, just return back false.
			return false;
		}

		// look for recaptchaV3 field on page
		let recaptchaField = document.getElementById("recaptcha-response");
		if(recaptchaField){
			data["Recaptcha Response"] = recaptchaField.value;
		}
		return data;
	}

	onSuccess(response) {
		if (!response.success) {
			this.onFailure();
			return;
		}

		this.form.classList.add("m-hide");
		this.successMessage.classList.remove("m-hide");
		this.formHeader.classList.add("message-shown");
		this.formLoader.classList.add('m-hide');
		this.form.classList.remove('m-form-hide');

		window.localStorage.setItem( 'popup_hideForever', 'true' );

	}

	onFailure() {
		this.form.classList.add("m-hide");
		this.failureMessage.classList.remove("m-hide");
		this.formHeader.classList.add("message-shown");
		this.formLoader.classList.add('m-hide');
		this.form.classList.remove('m-form-hide');
	}

}

Component.register(BlockAffiliationForm, 'BlockAffiliationForm');